import { Role } from '../../../../enums/Role';
import { GetPermissionFn } from '../types';

export const getAppPermission: GetPermissionFn = ({ hasRole }) => {
  if (hasRole(Role.planningReadonly)) {
    return { canView: true, canEdit: false };
  }
  return {
    canView: hasRole(Role.admin, Role.developer, Role.planningAccess),
    canEdit: true
  };
};
